// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FilterOutlinedSvg from "@ant-design/icons-svg/es/asn/FilterOutlined";
import AntdIcon from '../components/AntdIcon';

var FilterOutlined = function FilterOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FilterOutlinedSvg
  }));
};

FilterOutlined.displayName = 'FilterOutlined';
export default React.forwardRef(FilterOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/FilterOutlined.js
// module id = 1171
// module chunks = 0